import Vue from 'vue'
import VueResource from 'vue-resource'
import GetTextPlugin from 'vue-gettext'
// import VueRouter from 'vue-router'
import translations from './translations.json'

import moment from 'moment'
import Datepicker from 'vue2-datepicker'
import VueSlider from 'vue-slider-component'
import VueSelect from 'vue-select'
import { VueRecaptcha } from 'vue-recaptcha';
import {VueHammer} from 'vue2-hammer';

// import 'vue-slider-component/theme/default.css'
// import {default as Vuedals, Component as VuedalsComponent, Bus as VuedalsBus} from 'vuedals'

moment.locale('de'); // TODO: Moment locale should be dependent on App locale.
Object.defineProperty(Vue.prototype, '$moment', { value: moment });

const DateSelector = () => import('./Date-selector.vue');
const DateSelectorMonth = () => import('./Date-selector-month.vue');
const CompleteOverview = () => import('./Complete-overview.vue');
const Tabs = () => import('./Tabs.vue');
const Tab = () => import('./Tab.vue');


const EventConfigurator = () => import('./Event-configurator.vue')
const EventConfiguratorProgress = () => import('./Event-configurator-progress.vue')
const EventConfiguratorStatus = () => import('./Event-configurator-status.vue')

const DateTimeStep = () => import('./event-configurator-steps/Date-time-step.vue')
const EventAreaStep = () => import('./event-configurator-steps/Event-area-step.vue')
const PricingPackageStep = () => import('./event-configurator-steps/Pricing-package-step.vue')
const EquipmentStep = () => import('./event-configurator-steps/Equipment-step.vue')
const FoodBeveragesStep = () => import('./event-configurator-steps/Food-beverages-step.vue')
const ExtrasStep = () => import('./event-configurator-steps/Extras-step.vue')
const SummaryStep = () => import('./event-configurator-steps/Summary-step.vue')

import MainModule from './modules/main-module'
import './filters/Priceformat.js'

// globals
// Vue.prototype.$fecha = Fecha;
// Vue.prototype.$assetsUrl = '/bookings-system/img/';

// routes
/*const routes = [
  // path has to be different
  {
    name: 'date-time', 
    path: '/date-time', 
    component: DateTimeStep,
    props: true
  },
  { 
    name: 'event-area', 
    path: '/event-area', 
    component: EventAreaStep,
    props: true 
  },
  { 
    name: 'pricing-package', 
    path: '/pricing-package', 
    component: PricingPackageStep,
    props: true 
  },
  { 
    name: 'equipment', 
    path: '/equipment', 
    component: EquipmentStep,
    props: true 
  },
  { 
    name: 'food-beverages', 
    path: '/food-beverages', 
    component: FoodBeveragesStep,
    props: true 
  },
  { 
    name: 'extras', 
    path: '/extras', 
    component: ExtrasStep,
    props: true 
  },
  { 
    name: 'summary', 
    path: '/summary', 
    component: SummaryStep,
    props: true 
  }
]

const router = new VueRouter({
  routes: routes
});*/

/*router.beforeEach(function(to, from, next){
    let unlockedSteps = Vue.prototype.$mainModule.get('unlockedSteps');

    if (to.name == 'affiliate' || to.name == 'affiliate-search-results'){
      next();
      return;
    }

    if (to.path == '/'){
      next();
    }
    else{
      if (unlockedSteps == null){
        next('/');
      }
      else if (unlockedSteps.indexOf(to.name) == -1){
        next('/');
      }
      else{
        next();
      }
    }
});*/

Vue.use(VueResource);
// Vue.use(VueRouter); // ROUTER disabled (it was only needed for not used Event Configurator)
Vue.use(VueHammer);
// Vue.use(Vuedals);
Vue.use(GetTextPlugin, {
  translations: translations,

  availableLanguages: {
    deu: 'Deutsch',
    eng: 'English'
  },
  defaultLanguage: 'deu', // TODO: This should come from App settings.
  silent: true
});
// Vue.use(MainModule, router);

// components from plugins
// Vue.component('vuedals', VuedalsComponent);
Vue.component('datepicker', Datepicker);
Vue.component('vue-slider', VueSlider);
Vue.component('v-select', VueSelect);
Vue.component('vue-recaptcha', VueRecaptcha);

// custom comonents
Vue.component('event-configurator', EventConfigurator);
Vue.component('event-configurator-progress', EventConfiguratorProgress);
Vue.component('event-configurator-status', EventConfiguratorStatus);
Vue.component('date-selector', DateSelector);
Vue.component('date-selector-month', DateSelectorMonth);
Vue.component('complete-overview', CompleteOverview);
Vue.component('tab', Tab);
Vue.component('tabs', Tabs);

window.vue = new Vue({
  el: '.vue-root',
  // router: router,
  methods: {

  }
})
